import type { FC, PropsWithChildren } from 'react';
import { createContext, useState, useMemo, useContext } from 'react';

import { DEFAULT_VALUES } from 'app/config/urlParams.config';
import ConfigContext from 'app/common/ConfigContext';

interface ContextValue {
  period: StatPeriod;
  setPeriod: (period: StatPeriod) => void;
}

const PeriodContext = createContext<ContextValue>({
  period: DEFAULT_VALUES.period,
  setPeriod: () => null
});

const PeriodContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const { period: configuredPeriod } = useContext(ConfigContext);

  const [period, setPeriod] = useState<ContextValue['period']>(configuredPeriod);

  const value = useMemo(() => ({ period, setPeriod }), [period, setPeriod]);

  return <PeriodContext.Provider value={value}>{children}</PeriodContext.Provider>;
};

PeriodContextProvider.displayName = 'PeriodContextProvider';
PeriodContext.displayName = 'PeriodContext';

export default PeriodContext;
export { PeriodContextProvider };
